import React from 'react'

import HeaderMeta from 'components/HeaderMeta'

import PageHero, { Theme as PageHeroTheme } from 'components/blocks/PageHero'
import ContactInfo from 'components/blocks/ContactInfo'
import EmailForm from 'components/blocks/EmailForm'

const AskQuestionScreen: React.FC = (): React.ReactElement => {
  return (
    <div>
      <HeaderMeta
        title='Ask a Question | Insurance Lounge'
        description='Ask a Support Question'
        noIndex={true}
      />
      <PageHero theme={PageHeroTheme.contact}>
        Our Insurance Experts Are Here to Help
      </PageHero>
      <EmailForm
        showConsentToMarketingMessages={true}
        showPhoneNumber={true}
      />
      <ContactInfo />
    </div>
  )
}

export default AskQuestionScreen
